var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkKofi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h12v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8z",
    stroke: "#fff",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h1.5a2.5 2.5 0 0 1 0 5H16",
    stroke: "#fff",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 16.2l-2.3-2.2a1.4 1.4 0 0 1 2-2l.3.3.3-.3a1.4 1.4 0 0 1 2 2L10 16.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkKofi);
export default __webpack_public_path__ + "static/media/link-kofi.2b2d811264934ceb366a9b0c731d9e58.svg";
export { ForwardRef as ReactComponent };